export default {
  setUser(state, payload) {
    state.user.username = payload.username;
    state.user.roles = payload.roles;
    state.user.idToken = payload.idToken;
    state.user.accessToken = payload.accessToken;
  }
};
